import { useSelector } from 'react-redux';
import type { BlockContent } from '../grid/reduxStore/editorSlice';
import { selectBlockContent } from '../grid/reduxStore/editorSlice';
import type { RootState } from '../grid/reduxStore/Store';
import { GridBlockType } from 'services/entities/BlockTypes';
import { useContext } from 'react';
import { SelectionContext } from '../GridDndEditor/SelectedBlockInfoProvider';

export function useTextBlockSelected() {
  const { selectedBlockIdByWrapper, selectedSectionId } = useContext(SelectionContext);
  const blockId = selectedBlockIdByWrapper as string;
  const blocksContent = useSelector(
    (state: RootState) => selectedSectionId && selectBlockContent(state, selectedSectionId, blockId)
  ) as BlockContent;

  return blocksContent?.type == GridBlockType.TEXT;
}
